import { useMemo, useRef } from "react"
import { track } from '@vercel/analytics'
import useGame from "./stores/useGame"
import './style.css'

export default function UI()
{     
    const thruster = useGame((state) => state.thruster)
    const phase = useGame((state) => state.phase)
    const reset = useGame((state) => state.reset)
    const zoom = useGame((state) => state.zoom)

    const het  = useGame((state) => state.het)
    const mpt  = useGame((state) => state.mpt)
    const bpt  = useGame((state) => state.bpt)
    const cgt  = useGame((state) => state.cgt)

    const orientation = useGame((state) => state.orientation)

    const infoPanel = useGame((state) => state.infoPanel)

    const s_fd = useGame((state) => state.s_fd)
    const s_pr = useGame((state) => state.s_pr)
    const s_ps = useGame((state) => state.s_ps)

    const c_fm = useGame((state) => state.c_fm)
    const c_fi = useGame((state) => state.c_fi)
    const c_ss = useGame((state) => state.c_ss)

    const c_fp = useGame((state) => state.c_fp)
    const c_pr1 = useGame((state) => state.c_pr1)
    const c_pr2 = useGame((state) => state.c_pr2)
    const c_cp = useGame((state) => state.c_cp)

    const c_fd1 = useGame((state) => state.c_fd1)
    const c_fd2 = useGame((state) => state.c_fd2)
    const c_sf1 = useGame((state) => state.c_sf1)
    const c_sf2 = useGame((state) => state.c_sf2)
    const c_iv1 = useGame((state) => state.c_iv1)
    const c_iv2 = useGame((state) => state.c_iv2)

    const c_to = useGame((state) => state.c_to)
    const c_nz = useGame((state) => state.c_nz)

    // Check for sc=true URL parameter to disable external links
    const isScMode = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search)
        return urlParams.get('sc') === 'true'
    }, [])

    // Helper function to conditionally open URLs (disabled when sc=true)
    const openUrl = (url) => {
        if (!isScMode) {
            window.open(url)
        }
    }

    var b = document.documentElement;
                  b.setAttribute('data-useragent',  navigator.userAgent);
                  b.setAttribute('data-platform', navigator.platform );
                  b.className += ((!!('ontouchstart' in window) || !!('onmsgesturechange' in window))?' touch':'');
    

    const heading = useRef('null')
    const subHeading = useRef('null')

    useMemo(() => {
        if(infoPanel === 'null' && phase != 'zoomed')
            {
                heading.current = 'SATELLITE PROPULSION'
                subHeading.current = 'CHOOSE YOUR THRUST'
            }

        if(infoPanel === 'null' && phase === 'zoomed' && thruster === 'HET')
            {
                heading.current = 'HALL-EFFECT'
                subHeading.current = 'THRUSTERS'
            }

        if(infoPanel === 'null' && phase === 'zoomed' && thruster === 'MPT')
            {
                heading.current = 'MONO-PROPELLANT'
                subHeading.current = 'THRUSTERS'
            }

        if(infoPanel === 'null' && phase === 'zoomed' && thruster === 'BPT')
            {
                heading.current = 'BI-PROPELLANT'
                subHeading.current = 'THRUSTERS'
            }

        if(infoPanel === 'null' && phase === 'zoomed' && thruster === 'CGT')
            {
                heading.current = 'COLD GAS'
                subHeading.current = 'THRUSTERS'
            }

        if(infoPanel === 'S_FD' && phase === 'zoomed') {
            if(thruster === 'HET') {
                heading.current = 'Flow Divider';
                subHeading.current = undefined;
            } else if(['CGT','MPT','BPT'].includes(thruster)) {
                heading.current = 'Thruster';
                subHeading.current = undefined;
            }
        }

        if(infoPanel === 'S_PR' && phase === 'zoomed') {
            if(['HET','CGT'].includes(thruster)) {
                heading.current = 'Pressure Regulation';
                subHeading.current = undefined;
            } else if(['MPT','BPT'].includes(thruster)) {
                heading.current = 'Pressurization &';
                subHeading.current = 'Pressure Regulation';
            }
        }

        if(infoPanel === 'S_PS' && phase === 'zoomed')
            {
                heading.current = 'Propellant Storage'
                subHeading.current = undefined
            }

    }, [infoPanel, phase, thruster])

    //***Section and Component navigation helpers***//
    const sections = ['S_FD', 'S_PR', 'S_PS']
    const components = {
            HET: {
                S_FD: ['C_FM', 'C_FI', 'C_SS'],
                S_PR: ['C_FP', 'C_CP', 'C_PR2'],
                S_PS: ['C_FD1', 'C_PR1', 'C_SF1', 'C_IV1'],
            },
            CGT: {
                S_FD: ['C_NZ', 'C_SS'],
                S_PR: ['C_FP', 'C_CP', 'C_PR2'],
                S_PS: ['C_FD1', 'C_SF1', 'C_IV1', 'C_PR1'],
            },
            MPT: {
                S_FD: ['C_TO', 'C_SS'],
                S_PR: ['C_SF2', 'C_PR2', 'C_IV2', 'C_CP', 'C_FD2'],
                S_PS: ['C_FD1', 'C_SF1', 'C_IV1', 'C_PR1' ],
            },
            BPT: {
                S_FD: ['C_NZ', 'C_TO', 'C_SS'],
                S_PR: ['C_SF2', 'C_PR2', 'C_IV2', 'C_CP', 'C_FD2'],
                S_PS: ['C_FD1', 'C_IV1', 'C_PR1', 'C_SF1'],
            },
        }
    const componentSetters = {
        C_FM: c_fm,
        C_FI: c_fi,
        C_SS: c_ss,
        C_FP: c_fp,
        C_PR1: c_pr1,
        C_PR2: c_pr2,
        C_CP: c_cp,
        C_FD1: c_fd1,
        C_FD2: c_fd2,
        C_SF1: c_sf1,
        C_SF2: c_sf2,
        C_IV1: c_iv1,
        C_IV2: c_iv2,
        C_TO: c_to,
        C_NZ: c_nz,
    }

    function nextSection(current) {
        const idx = sections.indexOf(current)
        return sections[(idx + 1) % sections.length]
    }
    function prevSection(current) {
        const idx = sections.indexOf(current)
        return sections[(idx - 1 + sections.length) % sections.length]
    }

    function isSection(panel) {
        return sections.includes(panel);
    }

    function getCurrentSectionFromComponent(panel) {
        // Find which section this component belongs to for the current thruster
        const compMap = components[thruster];
        for (const section of sections) {
            if (compMap[section].includes(panel)) return section;
        }
        return null;
    }

    const next = () => {
        // Level 1: Sections
        if (sections.includes(infoPanel)) {
            const nextSec = nextSection(infoPanel);
            if (nextSec === 'S_FD') s_fd();
            else if (nextSec === 'S_PR') s_pr();
            else if (nextSec === 'S_PS') s_ps();
            return;
        }
        // Level 2: Components
        const section = getCurrentSectionFromComponent(infoPanel);
        if (!section) return;
        const compArr = components[thruster][section];
        const idx = compArr.indexOf(infoPanel);
        const nextIdx = (idx + 1) % compArr.length;
        const nextComp = compArr[nextIdx];
        // Call the correct setter for the next component
        if (nextComp && componentSetters[nextComp]) {
            componentSetters[nextComp]();
        }
    }

    const previous = () => {
        // Level 1: Sections
        if (sections.includes(infoPanel)) {
            const prevSec = prevSection(infoPanel);
            if (prevSec === 'S_FD') s_fd();
            else if (prevSec === 'S_PR') s_pr();
            else if (prevSec === 'S_PS') s_ps();
            return;
        }
        // Level 2: Components
        const section = getCurrentSectionFromComponent(infoPanel);
        if (!section) return;
        const compArr = components[thruster][section];
        const idx = compArr.indexOf(infoPanel);
        const prevIdx = (idx - 1 + compArr.length) % compArr.length;
        const prevComp = compArr[prevIdx];
        if (prevComp && componentSetters[prevComp]) {
            componentSetters[prevComp]();
        }
    }

        return <>

        <div className='banner-top'>
            <img src="./the-lee-co-full-white.svg" className="image-wrap" onClick={()=>{openUrl('https://www.darkstarlabs.io/'); track('Lee_Logo_Clicked');}}></img>
        </div> 

        <div className='interface'>
            { phase === 'zoomed' && <>

                <div className="action-card" >
                    <br></br>
                    <div className='navButtonThrusterRed' onClick={() => {reset(); zoom(); track('Returned_To_Satellite_View');}}> SATELLITE VIEW </div> 
                </div> </>
            }

        </div> 
        <div className='interface'>
            { infoPanel === 'null' && <>
                <div className="center-card" >
                    <button className={`navButtonThruster ${phase === 'zoomed' && thruster === 'HET' ? 'navButtonThrusterSelected' : ''}`} onClick={() => {het(); if(phase === 'standard') {zoom()}; track('Explore_Hall_Effect_Viewed');}}> HALL EFFECT </button> 
                    <button className={`navButtonThruster ${phase === 'zoomed' && thruster === 'MPT' ? 'navButtonThrusterSelected' : ''}`} onClick={() => {mpt(); if(phase === 'standard') {zoom()}; track('Explore_Mono_Propellant_Viewed');}}> MONO-PROPELLANT </button> 
                    <button className={`navButtonThruster ${phase === 'zoomed' && thruster === 'BPT' ? 'navButtonThrusterSelected' : ''}`} onClick={() => {bpt(); if(phase === 'standard') {zoom()}; track('Explore_Bi_Propellant_Viewed');}}> BI-PROPELLANT </button> 
                    <button className={`navButtonThruster ${phase === 'zoomed' && thruster === 'CGT' ? 'navButtonThrusterSelected' : ''}`} onClick={() => {cgt(); if(phase === 'standard') {zoom()}; track('Explore_Cold_Gas_Viewed');}}> COLD GAS </button> 
                </div>
            </>}

                </div>

        <div className='heroTitle'>

                <div className='redHead'>{infoPanel !== 'null' ? thruster === 'HET' ? 'HALL EFFECT THRUSTERS' : thruster === 'MPT' ? 'MONO-PROPELLANT THRUSTERS' : thruster === 'BPT' ? 'BI-PROPELLANT THRUSTERS' : thruster === 'CGT' ? 'COLD GAS THRUSTERS' : 'SPACE' : 'SPACE'}</div>
                <div className='heading'>{heading.current}</div> 
                <div className='subheading'>{subHeading.current}</div>
                <div className='hline'></div>


        </div> 


        <div id="S_FD" className='p'>

            {orientation != 'portrait' && 
            <>
                {thruster === 'HET' && (
                    <>
                        {navigator.platform != 'iPad' && <div className='body'>Precise anode-to-cathode flow ratio is vital for efficient and stable thruster operation. This balance ensures proper ionization for thrust, neutralizes the ion beam preventing spacecraft charging, and optimizes propellant use and power efficiency. Imbalances can lead to insufficient ionization, unstable beams, erratic plasma, and wasted propellant, impacting performance and mission life. Maintaining the correct ratio is key for long-lasting, high-performance thrusters.</div>}
                        {navigator.platform === 'iPad' && <div className='body'>A precise anode-to-cathode flow ratio is vital for efficient and stable thruster operation. Maintaining the correct ratio is key for long-lasting, high-performance thrusters.</div>}
                    </>
                )}
                {thruster === 'BPT' && (
                    <div className='body'>In satellite propulsion systems, thrusters play a crucial role by combining an oxidizer and propellant within a combustion chamber to generate thrust. To enhance the efficiency of this process, atomizing one or both substances can improve their mixing and ignition.</div>
                )}
                {thruster === 'MPT' && (
                    <div className='body'>In the reaction chamber, propellant enters a catalyst bed and undergoes an exothermic decomposition reaction, releasing heat. Nozzles then convert this thermal energy into kinetic energy in order to produce thrust. Satellites often use multiple thrusters to maintain precise control.</div>
                )}
                {thruster === 'CGT' && (
                    <div className='body'>Cold gas thrusters are simple, low-thrust propulsion systems used in spacecraft for small manoeuvres, such as attitude control and station-keeping. They operate by expelling a pressurised gas (often nitrogen) through a nozzle, generating thrust without combustion or heating, making them safe and reliable.</div>
                )}
            </>
            }
            {orientation === 'portrait' && (
                <>
                    {thruster === 'HET' && <div className='body'>A precise anode-to-cathode flow ratio is vital for efficient and stable thruster operation. Maintaining the correct ratio is key for long-lasting, high-performance thrusters.</div>}
                    {thruster === 'BPT' && (
                        <div className='body'>In satellite propulsion systems, thrusters play a crucial role by combining an oxidizer and propellant within a combustion chamber to generate thrust. To enhance the efficiency of this process, atomizing one or both substances can improve their mixing and ignition.</div>
                    )}
                    {thruster === 'MPT' && (
                        <div className='body'>In the reaction chamber, propellant enters a catalyst bed and undergoes an exothermic decomposition reaction, releasing heat. Nozzles then convert this thermal energy into kinetic energy in order to produce thrust. Satellites often use multiple thrusters to maintain precise control.</div>
                    )}
                    {thruster === 'CGT' && (
                        <div className='body'>Cold gas thrusters are simple, low-thrust propulsion systems used in spacecraft for small manoeuvres, such as attitude control and station-keeping.</div>
                    )}
                </>
            )}

                        <br></br>

                <div className='buttonRow'>

                    <div className='buttonRow' style={{justifyContent: 'left', width: '49%'}}>
                        <div className='navButton' onClick={() => {reset(); track(thruster + '_S_FD_Back_Btn_Clicked');}}>BACK</div>
                    </div>

                    <div className='buttonRow' style={{justifyContent: 'right', width: '49%'}}>
                        <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_S_FD_Prev_Btn_Clicked');}}>  </div> 
                        <div id="FW"  className='arrowButton' onClick={()=>{next(); track(thruster + '_S_FD_Next_Btn_Clicked');}}>  </div> 
                    </div>

                </div> 
        </div>

        <div id="S_PR" className='p'>


            {orientation != 'portrait' && (
                <>
                    {thruster === 'HET' && (
                        <>
                            {navigator.platform != 'iPad' && <div className='body'>Main functions of a pressure regulation system are to reduce the very high pressure of the stored propellant to the pressure rating of the components on the low-pressure side of the system, and to set an exact pressure upstream of the flow divider. Dropping the pressure protects the low-pressure components while setting a precise pressure helps the system provide the same flow needed in both the anode and cathode.</div>}
                            {navigator.platform === 'iPad' && <div className='body'>The pressure regulation system reduces the extremely high pressure of the stored propellant to the pressure rating of the components on the low-pressure side of the system.</div>}
                        </>
                    )}
                    {(thruster === 'MPT' || thruster === 'BPT') && (
                        <div className='body'>To maintain safe and stable satellite propulsion without relying on pumps, inert gases like helium or nitrogen pressurize propellant tanks. Stored at higher pressures, these gases flow through restrictors or regulators to maintain optimal tank pressure, minimizing leakage and extending satellite life.</div>
                    )}
                    {thruster === 'CGT' && (
                        <div className='body'>The pressure regulation system reduces the high pressure of stored propellant to a safer level compatible with downstream components. This ensures those parts operate within their pressure limits, preventing damage and maintaining overall system safety and performance.</div>
                    )}
                </>
            )}
            {orientation === 'portrait' && (
                <>
                    {thruster === 'HET' && <div className='body'>The pressure regulation system reduces the extremely high pressure of the stored propellant to the pressure rating of the components on the low-pressure side of the system.</div>}
                    {(thruster === 'MPT' || thruster === 'BPT') && (
                        <div className='body'>To maintain safe and stable satellite propulsion without relying on pumps, inert gases like helium or nitrogen pressurize propellant tanks. Stored at higher pressures, these gases flow through restrictors or regulators to maintain optimal tank pressure, minimizing leakage and extending satellite life.</div>
                    )}
                    {thruster === 'CGT' && (
                        <div className='body'>The pressure regulation system reduces the high pressure of stored propellant to a safer level compatible with downstream components. This ensures those parts operate within their pressure limits, preventing damage and maintaining overall system safety and performance.</div>
                    )}
                </>
            )}

            <br></br>

                <div className='buttonRow'>

                    <div className='buttonRow' style={{justifyContent: 'left', width: '49%'}}>
                        <div className='navButton' onClick={() => {reset(); track(thruster + '_S_PR_Back_Btn_Clicked');}}>BACK</div>
                    </div>
                    
                    <div className='buttonRow' style={{justifyContent: 'right', width: '49%'}}>
                        <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_S_PR_Prev_Btn_Clicked');}}>  </div> 
                        <div id="FW"  className='arrowButton' onClick={()=>{next(); track(thruster + '_S_PR_Next_Btn_Clicked');}}>  </div> 
                    </div>

                </div> 
        </div> 

        <div id="S_PS" className='p'>

            
            {orientation != 'portrait' && 
            <>
                {thruster === 'HET' && (
                    <>
                        {navigator.platform != 'iPad' && <div className='body'>A small satellite's lifespan – typically 3-7 years in low Earth orbit (LEO) – depends heavily on how well the propulsion system stores propellant. Leakage ratings for components responsible for storage on the high pressure side are critical, as slow leaks can cause continuous loss of fuel and shorten spacecraft (or mission) life.</div>}
                        {navigator.platform === 'iPad' && <div className='body'>A small satellite's lifespan – typically 3-7 years in low Earth orbit (LEO) – depends heavily on how well the propulsion system stores propellant.</div>}
                    </>
                )}
                {thruster === 'MPT' && (
                    <div className='body'>Liquid propellant is stored in low-pressure tanks and expelled using pneumatic pressurant. While these tanks are lightweight due to their low pressure, they must be shielded from high pressure exposure if the system fails.</div>
                )}
                {thruster === 'CGT' && (
                    <div className='body'>A satellite's lifespan hinges on how well its propulsion system retains propellant. Leakage ratings in components on the storage or high pressure side are crucial. Once the onboard propellant is depleted, the satellite must be re-entered and destroyed.</div>
                )}
                {thruster === 'BPT' && (
                    <div className='body'>Liquid fuel and oxidizer are stored in low pressure tanks and pushed out with pneumatic pressurants. To prevent the premature mixing, each tank is filled through separate fill and drain valves and kept apart until combined in the combustion chamber.</div>
                )}
            </>
            }
            {orientation === 'portrait' && (
                <>
                    {thruster === 'HET' && <div className='body'>A small satellite's lifespan – typically 3-7 years in low Earth orbit (LEO) – depends heavily on how well the propulsion system stores propellant.</div>}
                    {thruster === 'MPT' && (
                        <div className='body'>Liquid propellant is stored in low-pressure tanks and expelled using pneumatic pressurant. While these tanks are lightweight due to their low pressure, they must be shielded from high pressure exposure if the system fails.</div>
                    )}
                    {thruster === 'CGT' && (
                        <div className='body'>A satellite's lifespan hinges on how well its propulsion system retains propellant. Leakage ratings in components on the storage or high pressure side are crucial. Once the onboard propellant is depleted, the satellite must be re-entered and destroyed.</div>
                    )}
                    {thruster === 'BPT' && (
                        <div className='body'>Liquid fuel and oxidizer are stored in low pressure tanks and pushed out with pneumatic pressurants. To prevent the premature mixing, each tank is filled through separate fill and drain valves and kept apart until combined in the combustion chamber.</div>
                    )}
                </>
            )}

            <br></br>

                <div className='buttonRow'>

                    <div className='buttonRow' style={{justifyContent: 'left', width: '49%'}}>
                        <div className='navButton' onClick={() => {reset(); track(thruster + '_S_PS_Back_Btn_Clicked');}}>BACK</div>
                    </div>
                    
                    <div className='buttonRow' style={{justifyContent: 'right', width: '49%'}}>
                        <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_S_PS_Prev_Btn_Clicked');}}> </div> 
                        <div id="FW"  className='arrowButton' onClick={()=>{next(); track(thruster + '_S_PS_Next_Btn_Clicked');}}>  </div> 
                    </div>

                </div> 
        </div> 

        <div id="C_FM" className='p'>
        <div className='heading'>Flow Metering</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_FM_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_FM_Next_Btn_Clicked');}}>  </div> 
        </div>

        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>Accurate anode and cathode flow division is essential for thruster performance, controlled by restrictors with Lohm rates ranging from 30,000-3 million Lohms. Traditional orifices (as small as 13 µm) are vulnerable to contamination and manufacturing challenges. The Lee Company’s innovative multi-orifice Visco Jet® technology achieves the same restriction with larger minimum passages, significantly reducing the risk of clogging.</div>}
            {navigator.platform === 'iPad' &&  <div className='body'>Accurate division of anode and cathode flow is essential for thruster performance.</div>}

        </>
        }
        {orientation === 'portrait' &&  <div className='body'>Accurate division of anode and cathode flow is essential for thruster performance.</div>}

                    <br></br>
                <div className='buttonRow'>
                    <div className='navButton' onClick={() => {s_fd(); track(thruster + '_C_FM_Back_Btn_Clicked');}}>BACK</div>
                    <div className='textButtonContainerClear' onClick={() => {}}>
                        <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/187-visco-jet-multi-orifice-restrictor/'); track(thruster + '_C_FM_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                        <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/187-visco-jet-multi-orifice-restrictor/'); track(thruster + '_C_FM_Solutions_Btn_Clicked');}}></div>
                    </div>
                </div>
        </div> 

        <div id="C_FI" className='p'>
        <div className='heading'>Filters</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_FI_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_FI_Next_Btn_Clicked');}}>  </div> 
        </div>

        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>Protecting the narrow passages of the flow divider is essential to thruster performance – whether you’re using single orifice restrictors or multi-orifice restrictors with Visco Jet® technology from The Lee Company. Clogs in any flow path can lead to failure. Filters help to reduce risk in your mission by trapping FOD generated from 3D-printed manifolds, weld flash, or other system debris.</div>}
            {navigator.platform === 'iPad' &&  <div className='body'>Protecting the narrow passages of the flow divider is essential to thruster performance.</div>}

        </>
        }

        {orientation === 'portrait' &&  <div className='body'>Protecting the narrow passages of the flow divider is essential to thruster performance.</div>}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_fd(); track(thruster + '_C_FI_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/ultra-fine-230-flange-mount-316l/'); track(thruster + '_C_FI_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/ultra-fine-230-flange-mount-316l/'); track(thruster + '_C_FI_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 

        <div id="C_SS" className='p'>
        <div className='heading'>Selector Solenoid Valves</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_SSV_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_SSV_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT' || thruster === 'CGT') ? (
                        <div className='body'>Selector solenoid valves enable critical functions like activating a neutralizer to prevent spacecraft charging, switching to a backup cathode if the primary fails, or accommodating different thrust profiles. For varying thrust needs—like orbit raising versus station keeping—these valves can manage pressure to the flow divider or open parallel flow paths. Reliable solenoid valves ensure system redundancy and operational flexibility. <br></br><br></br> When multiple thrusters are used for redundancy, distributed thrust, or precise attitude control, solenoid valves are used to select which thrusters are used for each maneuver.</div>
                    ) : (
                        <div className='body'>Selector solenoid valves enable critical functions like activating a neutralizer to prevent spacecraft charging, switching to a backup cathode if the primary fails, or accommodating different thrust profiles. For varying thrust needs—like orbit raising versus station keeping—these valves can manage pressure to the flow divider or open parallel flow paths. Reliable solenoid valves ensure system redundancy and operational flexibility.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT' || thruster === 'CGT') ? (
                        <div className='body'>Reliable solenoid valves ensure system redundancy and operational flexibility.</div>
                    ) : (
                        <div className='body'>Reliable solenoid valves ensure system redundancy and operational flexibility.</div>
                    )}
                </>
            )}
        </> 
        }
        {orientation === 'portrait' && (
            <>
                {(thruster === 'MPT' || thruster === 'BPT' || thruster === 'CGT') ? (
                    <div className='body'>Reliable solenoid valves ensure system redundancy and operational flexibility.</div>
                ) : (
                    <div className='body'>Reliable solenoid valves ensure system redundancy and operational flexibility.</div>
                )}
            </>
        )}
        <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_fd(); track(thruster + '_C_SS_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    {(thruster === 'MPT' || thruster === 'BPT' || thruster === 'CGT') ? (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/iep-series-2-way-dispense-solenoid-valves/'); track(thruster + '_C_SS_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/iep-series-2-way-dispense-solenoid-valves/'); track(thruster + '_C_SS_Solutions_Btn_Clicked');}}></div>
                        </>
                    ) : (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_SS_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_SS_Solutions_Btn_Clicked');}}></div>
                        </>
                    )}
                </div>
            </div>
        </div> 

        <div id="C_CP" className='p'>
        <div className='heading' >COARSE PRESSURE REGULATION</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_CP_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_CP_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>High initial pressurant pressures (1000s of psi) must be reduced for the relatively low-pressure tanks (rated for 100s of psi) using a regulator or restrictor. The isolation valve opens to pressurize the propellant tank and may cycle frequently based on sensor feedback.</div>
                    ) : (
                        <div className='body'>High initial propellant storage pressures (1000s of psi) must be reduced for low-pressure components (rated for 100s of psi) using a regulator or restrictor/plenum system. The isolation valve cycles to fill the plenum based on sensor feedback and may cycle frequently during thruster operation, making it crucial for the coarse pressure relief solution to handle pressure fluctuations reliably.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>The isolation valve opens to pressurize the propellant tank and may cycle frequently based on sensor feedback.</div>
                    ) : (
                        <div className='body'>High initial propellant storage pressures must be reduced for low-pressure components using a regulator or restrictor/plenum system.</div>
                    )}
                </>
            )}

        </>
        }
        {orientation === 'portrait' && (
            <>
                {(thruster === 'MPT' || thruster === 'BPT') ? (
                    <div className='body'>The isolation valve opens to pressurize the propellant tank and may cycle frequently based on sensor feedback.</div>
                ) : (
                    <div className='body'>High initial propellant storage pressures must be reduced for low-pressure components using a regulator or restrictor/plenum system.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_CP_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_CP_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_CP_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 
        
        <div id="C_FP" className='p'>
        <div className='heading'>FINE PRESSURE REGULATION</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_FPR_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_FPR_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {thruster === 'CGT' ? (
                        <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster. Traditionally, proportional valves are used for pressure regulation, but they are complex and costly. A simpler, lower-cost alternative is pulse width modulation (PWM) of a high-speed solenoid valve. Both methods aim to establish a precise pressure just above the thruster.</div>
                    ) : (
                        <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster. Traditionally, proportional valves are used for pressure regulation, but they are complex and costly. A simpler, lower-cost alternative is pulse width modulation (PWM) of a high-speed solenoid valve. Both methods aim to establish a precise pressure in a plenum, just above the flow divider, to ensure accurate propellant flow to the anode and cathode.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {thruster === 'CGT' ? (
                        <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster.</div>
                    ) : (
                        <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster.</div>
                    )}
                </>
            )}

        </>
        }
        {orientation === 'portrait' && (
            <>
                {thruster === 'CGT' ? (
                    <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster.</div>
                ) : (
                    <div className='body'>After initial pressure reduction, precise regulation is needed for the thruster.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_FP_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/iep-series-2-way-dispense-solenoid-valves/'); track(thruster + '_C_FP_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/iep-series-2-way-dispense-solenoid-valves/'); track(thruster + '_C_FP_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 


        <div id="C_PR1" className='p'>
        <div className='heading'>PRESSURE RELIEF</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_PR(PS)_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_PR(PS)_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>A pressure relief valve is crucial for preventing over-pressurization, which can damage downstream components or cause tank rupture.<br></br> <br></br>
            Maximizing propellant load means operating near tank pressure limits. Unexpected pressure spikes can occur due to overfilling or thermal expansion during various mission phases. A reliable relief valve ensures system safety.</div>}
            {navigator.platform === 'iPad' && <div className='body'>A pressure relief valve is crucial for preventing over-pressurization, which can damage downstream components or cause tank rupture.</div>}
        </>
        }
        
        {orientation === 'portrait' && <div className='body'>A pressure relief valve is crucial for preventing over-pressurization, which can damage downstream components or cause tank rupture.</div>}
            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_ps(); track(thruster + '_C_PR(PS)_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/pressure-relief-valves/browse/'); track(thruster + '_C_PR(PS)_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/pressure-relief-valves/browse/'); track(thruster + '_C_PR(PS)_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 

        <div id="C_PR2" className='p'>
        <div className='heading'>PRESSURE RELIEF</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_PR(PR)_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_PR(PR)_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>Pressure relief valves are vital for safeguarding low-pressure components from over-pressurization. This can occur due to trapped propellant expansion from temperature changes, isolation valve leakage, or software issues.</div>}
            {navigator.platform === 'iPad' && <div className='body'>Pressure relief valves are crucial for protecting low-pressure components from overpressurization.</div>}

        </>
        }
        {orientation === 'portrait' && <div className='body'>Pressure relief valves are crucial for protecting low-pressure components from overpressurization.</div>}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_PR(PR)_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/pressure-relief-valves/'); track(thruster + '_C_PR(PR)_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/pressure-relief-valves/'); track(thruster + '_C_PR(PR)_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 

        <div id="C_FD1" className='p'>
        <div className='heading'>Fill and Drain Valves</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_FD_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_FD_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <> 
            {navigator.platform != 'iPad' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal. Unlike traditional valves with integrated actuators that add weight, Lee Company's innovative design utilizes a separate actuation tool, minimizing flown mass. Our valves offer exceptional leak tightness (under 10⁻⁷ sccs helium at 4000 psid) and various interface options.</div>}
            {navigator.platform === 'iPad' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal.</div>}

        </>
        }
        {orientation === 'portrait' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal.</div>}
            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_ps(); track(thruster + '_C_FD_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/fill-and-drain-valves/browse/'); track(thruster + '_C_FD_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/fill-and-drain-valves/browse/'); track(thruster + '_C_FD_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 
        
        <div id="C_FD2" className='p'>
        <div className='heading'>Fill and Drain Valves</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_FD_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_FD_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <> 
            {navigator.platform != 'iPad' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal. Unlike traditional valves with integrated actuators that add weight, The Lee Company's innovative design utilizes a separate actuation tool, minimizing flown mass. Our valves offer exceptional leak tightness (under 10⁻⁷ sccs helium at 4000 psid) and various interface options.</div>}
            {navigator.platform === 'iPad' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal.</div>}

        </>
        }
        {orientation === 'portrait' && <div className='body'>Fill and Drain Valves are essential for tank operations like purging, leak testing, and safe fluid removal.</div>}
            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_FD_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/fill-and-drain-valves/browse/'); track(thruster + '_C_FD_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/industries/space/products/fill-and-drain-valves/browse/'); track(thruster + '_C_FD_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 

        

        <div id="C_SF1" className='p'>
        <div className='heading'>System Filters</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_SF_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_SF_Next_Btn_Clicked');}}>  </div> 
        </div>

        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.<br></br> <br></br>
            Even when using clean gases, tiny contaminants like machine debris, residue from 3D-printed parts, or component erosion can cause blockages in system flow paths. Protecting these passages is key to maintaining reliable operation over the satellite’s lifespan.</div>}
            {navigator.platform === 'iPad' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.</div>}
        </>
        }
        {orientation === 'portrait' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.</div>}
        <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_ps(); track(thruster + '_C_SF_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/hi-bar-safety-screen-330-flange-mount-17-4ph/'); track(thruster + '_C_SF_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/hi-bar-safety-screen-330-flange-mount-17-4ph/'); track(thruster + '_C_SF_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 
        
        <div id="C_SF2" className='p'>
        <div className='heading'>System Filters</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_SF_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_SF_Next_Btn_Clicked');}}>  </div> 
        </div>

        {orientation != 'portrait' && 
        <>
            {navigator.platform != 'iPad' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.<br></br> <br></br>
            Even when using clean gases, tiny contaminants like machine debris, residue from 3D-printed parts, or component erosion can cause blockages in system flow paths. Protecting these passages is key to maintaining reliable operation over the satellite’s lifespan.</div>}
            {navigator.platform === 'iPad' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.</div>}
        </>
        }
        {orientation === 'portrait' && <div className='body'>Satellite propellant systems have very small flow paths, making contamination control especially vital.</div>}
        <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_SF_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/hi-bar-safety-screen-330-flange-mount-17-4ph/'); track(thruster + '_C_SF_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/hi-bar-safety-screen-330-flange-mount-17-4ph/'); track(thruster + '_C_SF_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 

        <div id="C_IV1" className='p'>
        <div className='heading'>Isolation Valves</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_IV_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_IV_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>Isolation valves are crucial for separating propellant in the tank from the thruster until needed. They must seal reliably across a wide pressure range as tank pressure decreases with use. Any leakage can lead to pressure buildup downstream or propellant loss to space.<br></br> <br></br>
                        For applications requiring repeated cycling to control downstream pressure, the valve's cycle life is critical.</div>
                    ) : (
                        <div className='body'>Isolation valves are crucial for separating high-pressure propellant in the tank from the thruster until needed. They must seal reliably across a wide pressure range as tank pressure decreases with use. Any leakage can lead to pressure buildup downstream or propellant loss to space.<br></br> <br></br>
                        For applications requiring repeated cycling to control downstream pressure, the valve's cycle life is critical.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>Isolation valves are crucial for separating the propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                    ) : (
                        <div className='body'>Isolation valves are crucial for separating the high pressure propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                    )}
                </>
            )}
        </>
        }
        {orientation === 'portrait' && (
            <>
                {(thruster === 'MPT' || thruster === 'BPT') ? (
                    <div className='body'>Isolation valves are crucial for separating the propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                ) : (
                    <div className='body'>Isolation valves are crucial for separating the high pressure propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_ps(); track(thruster + '_C_IV_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_IV_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_IV_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 
        
        <div id="C_IV2" className='p'>
        <div className='heading'>Isolation Valves</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_IV_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_IV_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>Isolation valves are crucial for separating gas in the pressurant tank from the propellant tanks until needed. They must seal reliably across a wide pressure range as tank pressure decreases with use. Any leakage can lead to pressure build-up downstream and pressurant loss.</div>
                    ) : (
                        <div className='body'>Isolation valves are crucial for separating high-pressure propellant in the tank from the thruster until needed. They must seal reliably across a wide pressure range as tank pressure decreases with use. Any leakage can lead to pressure buildup downstream or propellant loss to space.<br></br> <br></br>
                        For applications requiring repeated cycling to control downstream pressure, the valve's cycle life is critical.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {(thruster === 'MPT' || thruster === 'BPT') ? (
                        <div className='body'>Isolation valves are crucial for separating the propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                    ) : (
                        <div className='body'>Isolation valves are crucial for separating the high pressure propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                    )}
                </>
            )}
        </>
        }
        {orientation === 'portrait' && (
            <>
                {(thruster === 'MPT' || thruster === 'BPT') ? (
                    <div className='body'>Isolation valves are crucial for separating the propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                ) : (
                    <div className='body'>Isolation valves are crucial for separating the high pressure propellant in the tank from the thruster until it is needed. They must seal reliably across a wide range of pressures.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_pr(); track(thruster + '_C_IV_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_IV_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                    <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/solenoid-operated-pneumatic-isolation-valve/'); track(thruster + '_C_IV_Solutions_Btn_Clicked');}}></div>
                </div>
            </div>
        </div> 
        
        <div id="C_TO" className='p'>
    <div className='heading'>Trim Orifices</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_TO_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_TO_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {thruster === 'MPT' ? (
                        <div className='body'>Trim orifices are crucial for controlling the flow of propellant to the thruster. They must be designed to handle a wide range of pressures and flow rates, and any blockage or restriction can lead to performance issues or system failure.  For applications requiring precise flow control, the orifice's design and manufacturing tolerances are critical.</div>
                    ) : (
                        <div className='body'>Trim orifices are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates, and any blockage or restriction can lead to performance issues or system failure.<br></br> <br></br>
                        For applications requiring precise flow control, the orifice's design and manufacturing tolerances are critical.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {thruster === 'MPT' ? (
                        <div className='body'>Trim orifices are crucial for controlling the flow of propellant to the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                    ) : (
                        <div className='body'>Trim orifices are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                    )}
                </>
            )}
        </>
        }
        {orientation === 'portrait' && (
            <>
                {thruster === 'MPT' ? (
                    <div className='body'>Trim orifices are crucial for controlling the flow of propellant to the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                ) : (
                    <div className='body'>Trim orifices are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_fd(); track(thruster + '_C_TO_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    {thruster === 'MPT' ? (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_TO_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_TO_Solutions_Btn_Clicked');}}></div>
                        </>
                    ) : (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_TO_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/gas-rated-lee-jet-single-orifice-restrictor/'); track(thruster + '_C_TO_Solutions_Btn_Clicked');}}></div>
                        </>
                    )}
                </div>
            </div>
        </div> 

        <div id="C_NZ" className='p'>
        <div className='heading'>Nozzles</div>
        <div className='arrowRow' >
            <div id="BK" style={{marginRight: '16px' }} className='arrowButton2' onClick={()=>{previous(); track(thruster + '_C_NZ_Prev_Btn_Clicked');}}>  </div> 
            <div id="FW" style={{ }} className='arrowButton' onClick={()=>{next(); track(thruster + '_C_NZ_Next_Btn_Clicked');}}>  </div> 
        </div>
        {orientation != 'portrait' &&
        <>
            {navigator.platform != 'iPad' && (
                <>
                    {thruster === 'HET' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates, and any blockage or restriction can lead to performance issues or system failure.<br></br> <br></br>
                        For applications requiring precise flow control, the nozzle's design and manufacturing tolerances are critical.</div>
                    ) : thruster === 'MPT' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates, and any blockage or restriction can lead to performance issues or system failure.<br></br> <br></br>
                        For applications requiring precise flow control, the nozzle's design and manufacturing tolerances are critical.</div>
                    ) : thruster === 'BPT' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant and oxidizer into the combustion chamber, ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates often with specific cone angle and droplet size requirements. <br></br> <br></br> Any blockage or restriction can lead to performance issues or system failure.  For applications requiring precise flow control, the nozzle's design and manufacturing tolerances are critical.</div>
                    ) : (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant to space and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates, and any blockage or restriction can lead to performance issues or system failure.<br></br> <br></br>
                        For applications requiring precise flow control, the nozzle's design and manufacturing tolerances are critical.</div>
                    )}
                </>
            )}
            {navigator.platform === 'iPad' && (
                <>
                    {thruster === 'HET' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                    ) : thruster === 'MPT' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                    ) : thruster === 'BPT' ? (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant and oxidizer into the combustion chamber, ensuring efficient operation of the thruster.</div>
                    ) : (
                        <div className='body'>Nozzles are crucial for controlling the flow of propellant to space and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                    )}
                </>
            )}
        </>
        }
        {orientation === 'portrait' && (
            <>
                {thruster === 'HET' ? (
                    <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                ) : thruster === 'MPT' ? (
                    <div className='body'>Nozzles are crucial for controlling the flow of propellant in the tank and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                ) : thruster === 'BPT' ? (
                    <div className='body'>Nozzles are crucial for controlling the flow of propellant and oxidizer into the combustion chamber, ensuring efficient operation of the thruster.</div>
                ) : (
                    <div className='body'>Nozzles are crucial for controlling the flow of propellant to space and ensuring efficient operation of the thruster. They must be designed to handle a wide range of pressures and flow rates.</div>
                )}
            </>
        )}

            <br></br>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {s_fd(); track(thruster + '_C_NZ_Back_Btn_Clicked');}}>BACK</div>
                <div className='textButtonContainerClear' onClick={() => {}}>
                    {thruster === 'HET' ? (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}></div>
                        </>
                    ) : thruster === 'MPT' ? (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}></div>
                        </>
                    ) : thruster === 'BPT' ? (
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/spin-jet/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}></div>
                        </>
                    ) : null /* CGT button commented out for later use:
                        <>
                            <div className='textButton' onClick={() => {openUrl('https://www.theleeco.com/product/dispensing-atomizing-nozzles/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}>EXPLORE OUR SOLUTIONS</div>
                            <div className='textButtonArrow' onClick={() => {openUrl('https://www.theleeco.com/product/dispensing-atomizing-nozzles/'); track(thruster + '_C_NZ_Solutions_Btn_Clicked');}}></div>
                        </>
                    */ }
                </div>
            </div>
        </div> 

    </>
}





